
/* injects from baggage-loader */

'use strict';

import StageBaseController from '../stage-base.controller';

import { perguntas, palavras, elements1, elements2 , elements3} from './stage-two.const';

export default class StageTwoController extends StageBaseController {
	constructor($log, $state, $timeout, $q, Session, Dialog) {
		'ngInject';		
		super($log, $state, $q, Session, Dialog);

		this.$timeout = $timeout; 
		this.Dialog = Dialog;
		this.perguntas = perguntas;
		this.palavras = palavras;

		this.awnserValue = "";
		this.prize = "mapa";

		this.relation = 4;
		this.numCer = 15;
		this.numCav = 60;
		this.numFruta = 0;

		this.expected = 0;
	}

	$onInit() {
		this.checkStage();
	}

	prepareQuestion(name){
		let $ctrl = this;
		switch(name){
			case 'Leste':
			default:
			this.elements = elements1;
			this.randomizeValues([4,15],[50,200])
			this.elQuant(this.perguntas[0],this.relation,this.numCav);
			this.elements.forEach(function(obj){
				$ctrl.checkGrid(obj);
			});
			break;
			case 'Leste-2':
			this.prize = "red";
			this.elements = elements2;
			this.randomizeValuesSecond([2,8],[50,200])
			this.elQuantSecond(this.perguntas[1],this.numCer,this.numCav);
			this.elements.forEach(function(obj){
				$ctrl.checkGrid(obj);
			});
			break;
			case 'Montanha':
			this.prize = "mountain"
			this.elements = elements3;
			this.randomizeValuesThird([3,9],[5,200])
			this.elQuantThird(this.perguntas[2], this.numCav, this.numFruta, this.numCer);
			this.elements.forEach(function(obj){
				$ctrl.checkGrid(obj);
			});
			break;
		}
	}

	randomizeValues(cXcRange, cavalosRange){
		let cavXcer = this.getRandomInt(cXcRange);
		let numCav = this.getRandomInt(cavalosRange);
		let numCer = Math.floor(numCav/cavXcer)
		numCav = numCer * cavXcer;
		
		this.relation = cavXcer;
		this.numCer = numCer;
		this.numCav = numCav;

		this.expected = numCav;

		this.elements[1].value = this.relation;
		this.elements[1].minValue = this.relation;
	}

	randomizeValuesSecond(caixRange, frutaRange){
		let numCaixo = this.getRandomInt(caixRange);
		let numFruta = this.getRandomInt(frutaRange);
		let caxXfr = Math.floor(numFruta/numCaixo);
		numFruta = numCaixo * caxXfr;
		
		this.relation = caxXfr;
		this.numCer = numFruta/caxXfr;
		this.numCav = numFruta;

		this.expected = numFruta/numCaixo;

		this.elements[1].value = this.numCav;
		this.elements[1].maxValue = this.numCav;
		this.elements[0].value = this.numCer;
		this.elements[0].maxValue = this.numCer;
		// this.elements[1].minValue = this.relation;
	}

	randomizeValuesThird(cavRange, frutaRange){
		let numCav = this.getRandomInt(cavRange);
		let numFruta = this.getRandomInt(frutaRange);
		let cavXfr = this.getRandomInt([3,11]);
		let mod = numFruta%numCav;
		if(mod===0)
			numFruta+= this.getRandomInt([1,numFruta/numCav-1]);

		let maxFruta = numFruta*cavXfr ;
		let maxCav = numCav*cavXfr;

		this.$log.log({maxFruta, maxCav});

		this.relation = numFruta/numCav;

		this.numCav = numCav;
		this.numFruta = numFruta;
		this.numCer = maxFruta;

		this.expected = maxCav;

		this.elements[1].value = this.numFruta;
		this.elements[1].minValue = this.numFruta;
		this.elements[1].maxValue = maxFruta;
		this.elements[0].value = this.numCav;
		this.elements[0].minValue = this.numCav;
		this.elements[0].maxValue = maxCav;
	}

	elQuant(question, cavXcer, cavtotal){
		this.pergunta = question[0]+cavtotal+question[1]+question[2]+cavXcer+question[3];
	}

	elQuantSecond(question, numCaix, numLar){
		this.pergunta = question[0]+numCaix+question[1]+numLar+question[2];		
	}

	elQuantThird(question, numCav, numFruta, maxFruta){
		this.pergunta = question[0]+numCav+question[1]+numFruta+question[2]+maxFruta+question[3];		
	}

	checkValue(){
		let awnser = this.awnserValue;
		if(awnser !== ""){
			if((this.stageName === 'Leste-2') || (this.stageName === 'Montanha')){
				if(awnser === this.expected ){
					this.stageCompleted();
					this.Dialog.showFeedback(this.prize, this.goHome.bind(this));
				}
				else{
					this.Dialog.showAlert();
				}
			} else {
				if(awnser === this.expected / this.relation ){
					this.stageCompleted();
					this.Dialog.showFeedback(this.prize, this.goHome.bind(this));
				}
				else{
					this.Dialog.showAlert();
				}
			}
		}
	}

	updateRelation(obj){
		let $ctrl = this;
		if(this.stageName === 'Montanha'){
			return this.$q(function(resolve) {
				let objsToUp = $ctrl.elements.filter(o => o!==obj);
				objsToUp.forEach(function(o){
					let aux = $ctrl.relation;
					if(o.maxValue < obj.maxValue){
						o.value = Math.floor(obj.value/aux);
					} else {						
						o.value = Math.floor(aux * obj.value);
					}
				});
				resolve(objsToUp);
			});
		} else {
			return super.updateRelation(obj);
		}
	}

	$onDestroy(){
		this.resetStage();
	}

	resetStage(){
		this.elements.forEach(function(o){
			o.value = o.minValue;
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.controller.js